import React, {Component} from 'react';
import {Form, Field} from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import {FieldArray} from 'react-final-form-arrays'
import PropTypes from 'prop-types';

import ScheduleEFPriorityCreditorForm from './ScheduleEFPriorityCreditorForm';
import ScheduleEFNonPriorityCreditorForm from './ScheduleEFNonPriorityCreditorForm';

function confirm_remove_claim() {
  return confirm("Remove this claim?")
}

export default class ScheduleEFForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  render = () => (
    <Form
      initialValues={ this.props.data }
      onSubmit={ this.props.onSubmit }
      mutators={{
        ...arrayMutators
      }}
      render={({
                 handleSubmit,
                 // mutators: {push, pop}, // injected from final-form-arrays above
                 pristine,
                 form,
                 submitting,
                 values
               }) => {
        return (
        <form onSubmit={handleSubmit}>
          <fieldset className="ir-search-double">

            <table id="priority-creditors">
              <thead>
              <tr>
                <th>Priority creditors</th>
              </tr>
              </thead>
              <tbody>
              <FieldArray name="priority_creditors">
                {({fields}) =>
                  fields.map((name, index) => (
                    <tr key={name}>
                      <td>
                      {ScheduleEFPriorityCreditorForm(name)}
                      </td>
                      <td valign="top">
                        <span onClick={() => confirm_remove_claim() && fields.remove(index)}  style={{cursor: 'pointer'}}>
                          ❌
                        </span>
                      </td>
                    </tr>
                  ))}
              </FieldArray>
              </tbody>
            </table>

            <div className="editable">

              <button type="button" onClick={() => form.mutators.push('priority_creditors', undefined)}>
                Add priority creditor
              </button>

            </div>

            <table id="nonpriority-creditors">
              <thead>
              <tr>
                <th>Nonpriority creditors</th>
              </tr>
              </thead>
              <tbody>
              <FieldArray name="non_priority_creditors">
                {({fields}) =>
                  fields.map((name, index) => (
                    <tr key={name}>
                      <td>
                        {ScheduleEFNonPriorityCreditorForm(name)}
                      </td>
                      <td valign="top">
                        <span onClick={() => confirm_remove_claim() && fields.remove(index)}  style={{cursor: 'pointer'}}>
                          ❌
                        </span>
                      </td>
                    </tr>
                  ))}
              </FieldArray>

              </tbody>
            </table>

            <div className="editable">

              <button type="button" onClick={() => form.mutators.push('non_priority_creditors', undefined)}>
                Add nonpriority creditor
              </button>

            </div>


            <div className="buttons">

              <button type="submit" disabled={submitting || pristine} className="form-button form-submit">
                Submit
              </button>


              <button
                type="button"
                onClick={ () => { if(  pristine || confirm("You will lose unsaved changes") ) this.props.onCancel() } }
                disabled={submitting}>
                Cancel
              </button>

              <a style={{ float: 'right', color: 'gray', fontSize: '8px'}} onClick={() => alert(JSON.stringify(values, 0, 2)) }>
                Inspect Internal Structure</a>

            </div>
          </fieldset>

        </form>)
      }}
    />
  )
}


/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEFForm.jsx
 **/